import React from 'react';
import Layout from '../components/Layout';
import { Box} from '@mui/material';
import Steps from '../components/Steps';

const ContractRequest = () => {
    return (
        <Layout>
            <Box sx={{ padding: 4 }}>
                <Steps />
            </Box>
        </Layout>
    );
};

export default ContractRequest;
